import styled, { css } from 'styled-components';
import { toCSSCustomIdent } from '../../../utils/cssUtils';
import { injectTypography } from '../../../utils/injectTypography';
import { responsiveStyles } from '../../../utils/responsiveStyles';
export const gridSize = 48;
export const StyledCalendarGrid = styled.div.attrs((props) => ({
    weekdays: props.weekdays.map(toCSSCustomIdent),
})) `
  display: grid;

  grid-auto-rows: ${gridSize}px;

  ${(props) => {
    return responsiveStyles({
        'grid-template-columns': {
            xs: props.weekdays.map((day) => `[${day}] 1fr`).join(' '),
            m: props.weekdays.map((day) => `[${day}] ${gridSize}px`).join(' '),
        },
    }, props.theme.breakpoints);
}}
`;
export const StyledCalendarDayHeader = styled.div.attrs((props) => ({
    weekday: toCSSCustomIdent(props.weekday),
})) `
  display: flex;
  grid-column: ${(props) => props.weekday};
  align-items: center;
  justify-content: center;

  color: ${(props) => props.theme.colors.utility.neutral[80]};
  ${(props) => injectTypography(props, 'copy2')}
`;
export const StyledCalendarDay = styled.button.attrs((props) => ({
    weekday: toCSSCustomIdent(props.weekday),
})) `
  ${(props) => injectTypography(props, 'copy1')}

  grid-column: ${(props) => props.weekday};
  margin: 0;
  padding: 0;

  color: ${(props) => props.theme.colors.utility.neutral[80]};
  text-align: center;

  background-color: transparent;

  border: none;
  border-radius: 0;

  cursor: pointer;

  transition: 150ms ${(props) => props.theme.easing};
  transition-property: color, background-color;

  appearance: none;

  &:focus {
    z-index: 1;
  }

  &[aria-disabled='true'] {
    color: ${(props) => props.theme.colors.utility.neutral[30]};

    cursor: not-allowed;
  }

  &:not([aria-disabled='true']):hover {
    color: ${(props) => props.theme.colors.utility.neutral[0]};

    background-color: ${(props) => props.theme.colors.utility.neutral[80]};
  }

  &[aria-pressed='true'] {
    color: ${(props) => props.theme.colors.utility.neutral[0]};

    background-color: ${(props) => props.theme.colors.utility.neutral[100]};
  }

  &[aria-disabled='true'][aria-pressed='true'] {
    color: ${(props) => props.theme.colors.utility.neutral[10]};

    background-color: ${(props) => props.theme.colors.utility.neutral[50]};
  }

  ${(props) => props.selectedRange &&
    css `
      background-color: ${(props) => props.theme.colors.utility.neutral[5]};
    `}
`;
export const StyledTodayText = styled.span `
  padding-bottom: 2px;

  font-weight: ${(props) => props.theme.fontWeights.bold};

  border-bottom: 2px solid ${(props) => props.theme.colors.utility.neutral[100]};

  transition: border-color 150ms ${(props) => props.theme.easing};

  *[aria-disabled='true'] > & {
    border-color: ${(props) => props.theme.colors.utility.neutral[30]};
  }

  *[aria-pressed='true'] > &,
  *:not([aria-disabled='true']):hover > & {
    border-color: ${(props) => props.theme.colors.utility.neutral[0]};
  }

  *[aria-disabled='true'][aria-pressed='true'] > & {
    border-color: ${(props) => props.theme.colors.utility.neutral[10]};
  }
`;
//# sourceMappingURL=Calendar.styles.js.map